import FollowUpCadencesAPI from 'dashboard/api/crm/followUpCadences';

const state = {
    records: [],
    uiFlags: {
        isFetching: false,
        isCreating: false,
        isUpdating: false,
        isDeleting: false,
    },
};

const getters = {
    getCadences: s => s.records,
    getUIFlags: s => s.uiFlags,
};

const mutations = {
    SET_CADENCES(s, cadences) {
        s.records = cadences;
    },
    ADD_CADENCE(s, cadence) {
        s.records.push(cadence);
    },
    UPDATE_CADENCE(s, updated) {
        const idx = s.records.findIndex(r => r.id === updated.id);
        if (idx !== -1) s.records.splice(idx, 1, updated);
    },
    DELETE_CADENCE(s, id) {
        s.records = s.records.filter(r => r.id !== id);
    },
    SET_UI_FLAG(s, data) {
        s.uiFlags = { ...s.uiFlags, ...data };
    },
};

const actions = {
    async get({ commit }) {
        commit('SET_UI_FLAG', { isFetching: true });
        try {
            const { data } = await FollowUpCadencesAPI.getAll();
            commit('SET_CADENCES', data);
        } catch (error) {
            throw error;
        } finally {
            commit('SET_UI_FLAG', { isFetching: false });
        }
    },

    async create({ commit }, cadenceData) {
        commit('SET_UI_FLAG', { isCreating: true });
        try {
            const { data } = await FollowUpCadencesAPI.create(cadenceData);
            commit('ADD_CADENCE', data);
            return data;
        } catch (error) {
            throw error;
        } finally {
            commit('SET_UI_FLAG', { isCreating: false });
        }
    },

    async update({ commit }, { id, ...cadenceData }) {
        commit('SET_UI_FLAG', { isUpdating: true });
        try {
            const { data } = await FollowUpCadencesAPI.update(id, cadenceData);
            commit('UPDATE_CADENCE', data);
            return data;
        } catch (error) {
            throw error;
        } finally {
            commit('SET_UI_FLAG', { isUpdating: false });
        }
    },

    async delete({ commit }, id) {
        commit('SET_UI_FLAG', { isDeleting: true });
        try {
            await FollowUpCadencesAPI.delete(id);
            commit('DELETE_CADENCE', id);
        } catch (error) {
            throw error;
        } finally {
            commit('SET_UI_FLAG', { isDeleting: false });
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
